import {
  ArrayControlProps,
  isControl,
  rankWith,
  resolveSchema,
} from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { JSONObject } from "@spring-global/spring-datasources/lib/src/Types";
import { Icon, Timeline } from "rsuite";

const NotesListRenderer = (props: ArrayControlProps) => {
  if (!Array.isArray(props.data) || props.data.length === 0) {
    return (
      <div className="group-container">
        <div className="no-data">Nothing to display</div>
      </div>
    );
  }

  const formatDate = (itemKey: string, date: Date | string) => {
    const dt: Date = date instanceof Date ? date : new Date(date);
    const properties: JSONObject = props?.schema?.properties ?? {};
    const adProps: JSONObject = properties[itemKey]?.additionalProperties ?? {};
    const disableTimezoneConversion = adProps.disableTimezoneConversion;
    if (disableTimezoneConversion) {
      return new Date(dt.toISOString().replace("Z", "")).toLocaleString();
    }
    return dt.toLocaleString();
  };

  return (
    <div className="group-container">
      <Timeline className="NotesListRenderer" align="left">
        {props.data.map((note, index) => (
          <Timeline.Item key={index} dot={<Icon size="2x" icon="user" />}>
            <div>
              <span className="user">{note.nmUser}</span>
              <span className="date">
                {formatDate("dtCreated", note.dtCreated)}
              </span>
            </div>
            <div className="note">{note.dsNote}</div>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
};

export const notesListTester = rankWith(100, (uischema, schema, context) => {
  if (!isControl(uischema)) return false;
  if (uischema.options?.variant !== "notesList") return false;
  const resolvedSchema = resolveSchema(
    schema,
    uischema.scope,
    context?.rootSchema,
  );
  return resolvedSchema?.type === "array";
});

export default withJsonFormsArrayControlProps(NotesListRenderer);
